let code = 'geoapigestao';
let codeAPI = 'geoapi';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};